import { Context, type Cause, type Effect, Layer, type Scope } from "effect";
import type { TabStripEdges, TabStripFailure, TabStripWheel } from "./tab-strip-model.ts";
export class TabStripIo extends Context.Service<TabStripIo, {
  readonly measure: (target: HTMLElement) => Effect.Effect<unknown, TabStripFailure>;
  readonly watch: (target: HTMLElement, notify: (metrics: unknown) => void, canRead: () => boolean, report: (failure: TabStripFailure) => void) => Effect.Effect<void, TabStripFailure, Scope.Scope>;
  readonly page: (target: HTMLElement, direction: 1 | -1) => Effect.Effect<unknown, TabStripFailure>;
  readonly wheel: (target: HTMLElement, value: TabStripWheel) => Effect.Effect<unknown, TabStripFailure>;
}>()("workerstation/frontend/TabStripIo") {}
export const TabStripIoTest = (io: typeof TabStripIo.Service) => Layer.succeed(TabStripIo, io);
export type TabStripCommand =
  | { readonly _tag: "Receive"; readonly target: HTMLElement | null }
  | { readonly _tag: "Measure"; readonly target: HTMLElement | null }
  | { readonly _tag: "Page"; readonly target: HTMLElement | null; readonly input: unknown }
  | { readonly _tag: "Wheel"; readonly target: HTMLElement | null; readonly input: unknown };
export interface TabStripSession { readonly receive: (command: TabStripCommand) => Effect.Effect<void> }
export class TabStrips extends Context.Service<TabStrips, {
  readonly open: (notify: (edges: TabStripEdges) => void) => Effect.Effect<TabStripSession, never, Scope.Scope>;
  readonly failures: Effect.Effect<readonly Cause.Cause<TabStripFailure>[]>;
}>()("workerstation/frontend/TabStrips") {}
